<template>
    <div>
        <!-- <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="true"></b-loading> -->
        <div class=" p-5"  :style="(screenWidth <= 560 ? '' : (screenWidth <= 768 ? 'max-width: 768px; margin: auto;' : 'max-width: 968px; margin: auto;') )">
            
            <feather size="30" @click="goBack" type="arrow-left" class="my-5 mx-2 dark" style="top:0;position:absolute" ></feather>
            <!-- <feather v-if="cartCount > 0" @click="emptyCart" size="30" type="trash" class="mx-5 mx-2 dark" style="right:0;position:absolute" ></feather> -->
            <h4 class="title is-4 ml-5 pl-5">Shop  </h4>
            
            <!--  -->
            <!-- Total -->
            <div class="p-3 ">
                <div class="pt- pb-2">
                            <div class="pb-2 m-0 text-center">
                                <img style="height: 100px;object-fit: cover;" :src="form.logo" class="logo"/>
                                <!-- <p class="subtitle is-6 has-text-grey">Enter details below</p> -->
                            </div>
                            <div class="columns is-mobile">
                                <div class="column">
                                    <b-field label="Shop name" label-position="on-border" :type="fn.type" :message="fn.message">
                                        <b-input disabled="" autofocus v-model="form.name" placeholder="Name"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns is-mobile">
                                <div class="column">
                                    <b-field label="Categories" label-position="on-border" :type="ct.type" :message="ct.message">
                                        <b-input @input="validateCategories()" rows="10" type="textarea" v-model="form.categories" placeholder="Bio"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns is-mobile">
                                <div class="column">
                                    <b-field label="Email" label-position="on-border" :type="em.type" :message="em.message">
                                        <b-input @input="validateEmail()"  v-model="form.email" placeholder="test@email.com"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns is-mobile">
                                <div class="column is-4">
                                    <b-field label="Country" label-position="on-border" :type="cd.type" :message="cd.message">
                                        <b-input @input="validateCode()" v-model="form.phone.countryCode" placeholder="Country "></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="Tel" label-position="on-border" :type="tl.type" :message="tl.message">
                                        <b-input @input="validateTel()" v-model="form.phone.tel" placeholder="Phone "></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns is-mobile">
                                <div class="column">
                                    <b-field label="Location" label-position="on-border" message="">
                                        <b-input disabled v-model="form.location" placeholder=""></b-input>
                                    </b-field>
                                </div>
                            </div>

                            <b-field v-if="checkChanges" class="pt-1">
                                <b-button @click="onSubmit" rounded class="is-submit-button" expanded type="is-primary">Update</b-button>
                            </b-field>

                            <!-- {{ form }} -->
                        </div>
                <!-- <p class=""> :( No Free Coupons today</p> -->
            </div>

        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from "vuex"
    import { userService } from '../services';

    export default {
        name: "UserPage",
        data() {
            return {
                isLoading: false,
                isFullPage: true,
                screenWidth: 0,
                form: {
                    name: '',
                    email: '',
                    categories: '',
                    phone: {
                        countryCode: '',
                        tel: ''
                    },
                    logo: ''
                },
                ct: {
                    type:'',
                    message:'',
                },
                em: {
                    type:'',
                    message:'',
                },
                cd: {
                    type:'',
                    message:'',
                },
                tl:{
                    type:'',
                    message:'',
                },
                fn: {
                    type:'',
                    message:'',
                },
                ln:{
                    type:'',
                    message:'',
                },
                show: true
            }
        },
        computed: {
            ...mapGetters('auth', ['getUser']),
            checkChanges() {

                if (this.form.categories !== this.getUser.categories.join(',') || this.form.phone.countryCode !== this.getUser.phone.countryCode || this.form.phone.tel !== this.getUser.phone.tel || this.form.email !== this.getUser.email){
                    //
                    return true
                }

                return false
            }
        },
        mounted() {
            // this.business = this.$store.getters['cart/getCartBusiness']
            this.updateScreenWidth();
            this.onScreenResize();

            //
            this.form.name = this.getUser.name
            this.form.categories = this.getUser.categories
            this.form.name = this.getUser.name
            this.form.firstname = this.getUser.firstname
            this.form.lastname = this.getUser.lastname
            this.form.email = this.getUser.email
            this.form.phone.countryCode = this.getUser.phone.countryCode
            this.form.phone.tel = this.getUser.phone.tel
            this.form.location = this.getUser.locationName
            this.form.logo = this.getUser.logo

            this.form.categories = this.form.categories.join(',')
        },
        methods: {
            onScreenResize() {
                window.addEventListener("resize", () => {
                    this.updateScreenWidth();
                });
            },
            updateScreenWidth() {
                this.screenWidth = window.innerWidth;
            },
            goBack() {
                this.$router.back()
            },
            validateCategories() {
                if (this.form.categories.length < 5 && !this.form.categories.split(',')){
                    this.ct.type = 'is-danger';
                    this.ct.message ='Enter 3-characters or above'
                    return false
                }

                if (this.form.categories.length >= 5 && this.form.categories.split(',')){
                    this.ct.type = 'is-success';
                    this.ct.message =''
                    return true
                }
            },
            validateEmail() {

                const reg = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

                if (this.form.email.match(reg)) {
                        this.em.type = 'is-success';
                        this.em.message =''
                        return true
                } else {
                        this.em.type = 'is-danger';
                        this.em.message ='Kindly enter a valid email'
                        return false
                        
                }

            },
            validateFname() {
                if (this.form.firstname.length < 3){
                    this.fn.type = 'is-danger';
                    this.fn.message ='Enter 3-characters or above'
                    return false
                }

                if (this.form.firstname.length >= 3){
                    this.fn.type = 'is-success';
                    this.fn.message =''
                    return true
                }
            },
            validateCode() {
                if (this.form.phone.countryCode.length < 3){
                    this.cd.type = 'is-danger';
                    this.cd.message ='Enter 3-characters or above'
                    return false
                }

                if (this.form.phone.countryCode.length >= 3 && this.form.phone.countryCode.length  <= 4){
                    this.cd.type = 'is-success';
                    this.cd.message =''
                    return true
                }
            },
            validateTel() {
                if (this.form.phone.tel.length < 9){
                    this.tl.type = 'is-danger';
                    this.tl.message ='Enter 9-characters or above'
                    return false
                }

                if (this.form.phone.tel.length >= 9){
                    this.tl.type = 'is-success';
                    this.tl.message =''
                    return true
                }
            },
            validateLname() {
                if (this.form.lastname.length < 3){
                    this.ln.type = 'is-danger';
                    this.ln.message ='Enter 3-characters or above'
                    return false
                }

                if (this.form.lastname.length >= 3){
                    this.ln.type = 'is-success';
                    this.ln.message =''
                    return true
                }
            },
            openLoading() {
                this.isLoading = true
                setTimeout(() => {
                    this.isLoading = false
                }, 1.5 * 1000)
            },
            onSubmit(event) {
                // validate
                if ( !this.validateCategories() || !this.validateEmail() || !this.validateCode() || !this.validateTel()){
                    return
                }

                this.isLoading = true
                
                // ajax
                this.axios.post('/shop/update', this.form).then(response=>{
                    //
                    console.log(response.data)
                    // 
                    this.$buefy.toast.open(response.data)

                    // 
                    userService.getAll().then(() => {
                        // update
                        this.$store.dispatch('auth/updateUser')
                    })

                    if (this.form.email !== this.getUser.email) {

                        //
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: "Kindly sigin again, signin email is updated!",
                        })
                        // logout if email changed
                        this.logOut()
                    }

                }).catch(error=>{
                    //
                    this.isLoading = false
                    //
                    console.log(error)
                    //
                    this.$buefy.toast.open(error.response.data)
                })
                // alert(JSON.stringify(this.form))
            },
            onReset(event) {
                event.preventDefault()
                // Reset our form values
                this.form.email = ''
                this.form.name = ''
                this.form.food = null
                this.form.checked = []
                // Trick to reset/clear native browser form validation state
                this.show = false
                this.$nextTick(() => {
                this.show = true
                })
            },
            logOut() {
                this.open = false;
                //
                userService.logout().then(()=>{
                    //
                    this.$router.push('/signin')
                })
                //
                
            }
        }
    }
</script>

<style lang="scss" scoped>
    .link:hover, .link:focus {
        background: grey;
        background: #f4f4f4;
        border-radius: 1.2rem;
    }
</style>